import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/config';

@Injectable({
  providedIn: 'root',
})
export class NarudzbeService {
  constructor(private _http: HttpClient) {}

  dokumentPopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dokumentPopis', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPoslovniceTomo(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_poslovnicepartnera_tomo', a)
      .pipe(map((res: any) => res));
  }

  dokumentUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dokumentUredi', a)
      .pipe(map((res: any) => res));
  }

  dokumentstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dokumentstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  razlikaNarucenoIsporuceno(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'razlika_naruceno_isporuceno', a)
      .pipe(map((res: any) => res));
  }

  povezani_dokumenti_popis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'povezani_dokumenti_popis', a)
      .pipe(map((res: any) => res));
  }

  otpremnica_iz_narudzbe(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'otpremnica_iz_narudzbe', a)
      .pipe(map((res: any) => res));
  }


}
